module.exports = __webpack_public_path__ + "img/oaFlowData169@3x.773c315f.png";